module.exports = __webpack_public_path__ + "static/media/phone-icon.9287c23d.svg";